export default "__VITE_ASSET__xkxrXHXf__"